import { createSelector } from 'reselect';

const selectDBSBank = (state: any) => state.dbsBank;

export const selectDBSBankCurrentItem = createSelector([selectDBSBank], (dbsBank) => dbsBank.current);

export const selectDBSBankListItems = createSelector([selectDBSBank], (dbsBank) => dbsBank.list);

export const selectDBSBankItemById = (itemId: any) =>
    createSelector(selectDBSBankListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDBSBankQueryItems = createSelector([selectDBSBank], (dbsBank) => dbsBank.query);

export const selectDBSBankCreatedItem = createSelector([selectDBSBank], (dbsBank) => dbsBank.create);

export const selectDBSBankUpdatedItem = createSelector([selectDBSBank], (dbsBank) => dbsBank.update);

export const selectDBSBankReadItem = createSelector([selectDBSBank], (dbsBank) => dbsBank.read);

export const selectDBSBankDeletedItem = createSelector([selectDBSBank], (dbsBank) => dbsBank.delete);

export const selectDBSBankSearchedItems = createSelector([selectDBSBank], (dbsBank) => dbsBank.search);

export const selectDBSBankItemsCount = createSelector([selectDBSBank], (dbsBank) => dbsBank.count);

export const selectDBSBankItemsFilter = createSelector([selectDBSBank], (dbsBank) => dbsBank.filter);